import { lazy } from 'react';

export const LazySignFaxBridgePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--sign-fax-bridge-page" */ './sign-fax-bridge-page'
    ),
);
